module.exports = __webpack_public_path__ + "img/ic_topic_news-active.07df052d.svg";